import Button from "../components/Button";
import Collaboration from "../components/Collaboration";
import PageTitle from "../components/PageTitle";

function MyAccount() {
  return (
    <>
      <PageTitle title="Account" path={["Pages ", "My Account"]} />

      <div className="flex flex-col items-center p-12 shadow-custom_two max-w-md mx-auto font-fontOne mt-10">
        <h1 className="font-bold text-2xl mb-3">Login</h1>
        <p className=" text-sub_text_color mb-3">
          Please Login with account detail bellow
        </p>
        <form className=" w-full">
          <input
            className="block pl-2 w-full mb-5 h-10 border"
            placeholder="E-mail Address"
            type={"text"}
          />
          <input
            className="block pl-2 w-full mb-5 h-10 border"
            placeholder="Password"
            type={"password"}
          />
          <a
            href="/"
            className=" hover:text-black block text-sub_text_color mb-3"
          >
            Forgot your password?
          </a>
          <Button color={"pink"} className="w-full mb-3">
            Sign In
          </Button>
          <p className="text-center text-sub_text_color">
            Don't have an account yet?{" "}
            <a href="/" className="hover:text-black">
              Create One
            </a>
          </p>
        </form>
      </div>
      <Collaboration />
    </>
  );
}

export default MyAccount;
